import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2017_1993)" }, [
      _createElementVNode("path", {
        fill: "#525252",
        d: "M0 6.471c0 3.569 2.931 6.472 6.534 6.472a6.52 6.52 0 0 0 3.8-1.217l4.028 3.998a.97.97 0 0 0 .696.276c.557 0 .942-.414.942-.957a.93.93 0 0 0-.27-.665l-4.004-3.99a6.36 6.36 0 0 0 1.343-3.917C13.069 2.903 10.137 0 6.534 0S0 2.903 0 6.471m1.4 0c0-2.806 2.301-5.084 5.134-5.084s5.134 2.278 5.134 5.084-2.3 5.085-5.134 5.085c-2.833 0-5.134-2.279-5.134-5.085"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2017_1993" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }